/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PreviousInputs */



/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Common_PreviousInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_previous = /** @type {((inputs?: Common_PreviousInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PreviousInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Précédent")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anterior")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Anterior")
	if (locale === "it") return /** @type {LocalizedString} */ ("Precedente")
	return /** @type {LocalizedString} */ ("Previous")
});